import { Drawer } from "@mui/material";
import { GrClose } from "react-icons/gr";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import EmptyCart from "../../assets/empty-cart.png";
import { useCart } from "../../hooks/useCart";
import { t } from "../../translations";
import { Aa } from "../functions/Aa";
const CartDrawer = ({ open, onClose, onUpdateCart }) => {
  const history = useHistory();
  const cart = useSelector((state) => state.cart);
  const selectedChef = useSelector((state) => state.selectedChef);
  const selectedWhen = useSelector((state) => state.selectedWhen);
  const selectedLang = useSelector((state) => state.lang);

  // Use cart service for cart statistics
  const { getStats } = useCart();
  const cartStats = getStats();

  // Calculate current date (formatted for display)
  const getCurrentDate = () => {
    if (selectedWhen) {
      const date = new Date(selectedWhen);
      return date.toLocaleDateString(
        selectedLang === "fr" ? "fr-FR" : "en-US",
        {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric"
        }
      );
    }
    return "";
  };

  const handleQuantityChange = (item, newQty) => {
    if (onUpdateCart) {
      const updatedCart = cart.map((data) => {
        if (data?._id === item?._id) {
          return { ...data, qty: newQty };
        }
        return { ...data };
      });
      onUpdateCart(updatedCart);
    }
  };

  const handleIncrement = (item) => {
    const currentQty = cart?.find((data) => data?._id === item?._id)?.qty || 0;
    if (currentQty >= 10) {
      return;
    }
    handleQuantityChange(item, currentQty + 1);
  };

  const handleDecrement = (item) => {
    const currentQty = cart?.find((data) => data?._id === item?._id)?.qty || 0;
    if (currentQty <= 1) {
      return;
    }
    handleQuantityChange(item, currentQty - 1);
  };

  const handleViewCart = () => {
    history.push(
      `/order/chef/menu/cart?chef=${selectedChef?._id}&date=${selectedWhen}`
    );
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <div
        style={{
          width: 300
        }}
      >
        <span
          style={{
            margin: 10
          }}
        >
          <GrClose size={30} onClick={onClose} style={{ cursor: "pointer" }} />
        </span>
        <hr />
        <h2
          style={{
            padding: 7,
            marginLeft: 10
          }}
        >
          {cartStats.isEmpty
            ? ""
            : t("navbar.cart_order_from", selectedLang) +
              (Aa(selectedChef?.firstname) + " " + Aa(selectedChef?.lastname))}
        </h2>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          {cartStats.isEmpty && (
            <>
              <img
                alt="empty-cart"
                src={EmptyCart}
                style={{
                  marginTop: 30,
                  width: 200
                }}
                s
              />
              <p
                style={{
                  marginTop: 20,
                  fontSize: 16,
                  color: "#666",
                  textAlign: "center",
                  padding: "0 20px",
                  lineHeight: "1.4"
                }}
              >
                {t("navbar.empty_cart_message", selectedLang)}
              </p>
            </>
          )}
        </div>
        {!cartStats.isEmpty && (
          <>
            <span
              style={{
                marginLeft: 13,
                fontWeight: 500
              }}
            >
              {t("navbar.cart_order_delivery", selectedLang)}
              {getCurrentDate()}
            </span>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap"
              }}
            >
              {cart?.map((item) => (
                <div
                  className="section-food-list-right-cart-btn"
                  key={item?._id}
                >
                  <span
                    className="section-food-list-right-cart-btn-span"
                    onClick={() => handleDecrement(item)}
                  >
                    -
                  </span>
                  <span>{item?.qty}</span>
                  <span
                    className="section-food-list-right-cart-btn-span"
                    onClick={() => handleIncrement(item)}
                  >
                    +
                  </span>
                  <span
                    style={{
                      fontSize: 15
                    }}
                  >
                    {item?.name?.slice(0, 25) + "..."}
                  </span>
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: 15
                    }}
                  >
                    {"$" + (item?.cost * item?.qty)?.toFixed(2)}
                  </span>
                </div>
              ))}
              <div
                className="btn-see-cart"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 10,
                  width: "95%",
                  height: 50,
                  borderRadius: 25,
                  backgroundColor: "#FF114D",
                  marginTop: 20,
                  cursor: "pointer"
                }}
                onClick={handleViewCart}
              >
                <span
                  style={{
                    color: "#fff",
                    fontSize: 15
                  }}
                >
                  {t("navbar.see_cart", selectedLang)}
                </span>
                <span
                  style={{
                    backgroundColor: "#fff",
                    height: 40,
                    width: 80,
                    borderRadius: 20,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: 15,
                    fontWeight: 700
                  }}
                >
                  {"$" +
                    cart?.reduce((a, b) => a + b?.cost * b?.qty, 0)?.toFixed(2)}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </Drawer>
  );
};

export default CartDrawer;
